export const site = {
  name: "Anexya",
  legalName: "Anexya",
  founder: "Angélique Luminet",
  tagline: "Agent d'entretien professionnel à Vichy",
  baseUrl: "https://www.anexya.fr",
  phoneDisplay: "06 59 25 17 89",
  phoneHref: "tel:+33659251789",
  email: "contact@anexya.fr",
  emailHref: "mailto:contact@anexya.fr",
  address: {
    street: "35 rue jean ferlot",
    postalCode: "03200",
    city: "Vichy",
    region: "Auvergne-Rhône-Alpes",
    country: "FR",
  },
  hours: "Lun–Ven 07h–19h · Sam 08h–13h",
  siret: "938 665 544 00012",
  foundingYear: 2024,
  radiusKm: 30,
  geo: { lat: 46.1278, lng: 3.4267 },
  social: {
    facebook: "https://www.facebook.com/",
    instagram: "https://www.instagram.com/",
    linkedin: "https://www.linkedin.com/",
  },
} as const;

export const primaryKeywords = [
  "agent d'entretien Vichy",
  "nettoyage professionnel Vichy",
  "entreprise de nettoyage Vichy",
  "société de nettoyage Vichy",
  "nettoyage bureaux Vichy",
  "nettoyage copropriété Vichy",
  "nettoyage Airbnb Vichy",
  "ménage location courte durée Vichy",
  "conciergerie ménage Vichy",
  "nettoyage vitres Vichy",
  "nettoyage fin de chantier Vichy",
  "ménage professionnel Allier",
  "femme de ménage Vichy",
];
